<template>
  <v-app>
    <v-main>
      <v-container>
        <v-app-bar
          app
          flat
        >
          <v-img
            class="mx-2"
            :src="appLogo"
            max-height="150"
            max-width="150"
          ></v-img>
        </v-app-bar>

        <v-slide-x-transition mode="out-in">
          <router-view />
        </v-slide-x-transition>
      </v-container>
    </v-main>
    <SnackBar />
  </v-app>
</template>

<script>
export default {
  components: {
    SnackBar: () => import("@/components/utils/ErrorHandler.vue")
  },
  data() {
    return {
      appLogo: this.$appConfig.assets.img.custom.logo
    }
  }
}
</script>
